<template>
  <div>
    <q-layout view="hHh LpR fFf">
      <q-header elevated class="bg-accent text-white">
        <q-toolbar>
          <q-toolbar-title>Tecnologías sin zanja</q-toolbar-title>
          <div class="logo">
            <a href="https://www.veolia.es/hubgrade" target="_blank">
              <img src="@/assets/img/panel/hubgrade-blanco.svg" />
            </a>
          </div>
          <pre></pre>
          <pre></pre>
          <pre></pre>
          <pre></pre>
          <q-btn flat round dense icon="account_circle" to="logout" />
        </q-toolbar>
        <q-toolbar class="bg-white text-black shadow-4 rounded-borders">
          <q-tabs align="left" inline-label indicator-color="#9ace25">
            <q-route-tab
              to="/UsuariosTipo"
              label="Tipo Usuarios"
              name="usuarios_tipo"
            />
          </q-tabs>
        </q-toolbar>
      </q-header>
      <div></div>
      <br />
      <br />
      <br />

      <div ID="Div9" runat="server">
        <TSZ_Usuario_Interno />
      </div>
    </q-layout>
  </div>
</template>
<script>
import { Cookies } from 'quasar';

import TSZ_Usuario_Interno from '@/components/Usuarios/components/TSZ_Usuario_Interno.vue';
import '@/components/Usuarios/assets/css/css_usuario_vue.css';

import {
  QTabs,
  QRouteTab,
  QLayout,
  QHeader,
  QFooter,
  QDrawer,
  QPageContainer,
  QToolbar,
  QToolbarTitle,
  QMenu,
  QDialog
} from 'quasar';
export default {
  data: function () {
    return {};
  },
  components: {
    TSZ_Usuario_Interno,
    QTabs,
    QRouteTab,
    QLayout,
    QHeader,
    QFooter,
    QDrawer,
    QPageContainer,
    QToolbar,
    QToolbarTitle,
    QMenu,
    QDialog
  }
};
</script>

<style lang="scss" scoped>
.logo {
  img {
    margin-top: 10px;
    max-width: 135px;
    padding: 0px 0 0 0;
    height: 40px;
    align-items: center;
  }
  i {
    padding: 18px 2% 0 5%;
  }
}
</style>
